import ArrowRightSvg from '@assets/images/svg/arrow-right.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface ArrowRightIconProps {
  readonly size?: number;
  /** Stroke color — SVG uses currentColor. */
  readonly color?: string;
}

/**
 * Figma arrow-right — shaft + chevron tip for CTA trailing icons.
 * Default size 13 matches Universal CTAs; Bloom Experience passes 18.
 */
export function ArrowRightIcon({
  size = 13,
  color = '#1A1A1A',
}: Readonly<ArrowRightIconProps>) {
  return (
    <View style={[styles.container, { width: size, height: size }]}>
      <ArrowRightSvg width={size} height={size} color={color} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ArrowRightIcon;
